export const enum StorageKeys {
  AudioPlayerPlaybackSpeed = 'audioplayer_playbackSpeed',
  AudioDevicePreferences = 'audioDevicePreferences',
  AuthData = 'authData',
  AuthRedirect = 'authRedirect',
  CallsPageSearchParams = 'calls-page-search-params',
  Experiments = 'experiments',
  LastUsedFaxPhoneNumber = 'lastUsedFaxPhoneNumber',
  LastUsedOutboundPhoneNumber = 'lastUsedOutboundPhoneNumber',
  AppSettings = 'app-settings',
  PbxAppSettings = 'pbx-app-settings',
  UserSessionData = 'user-session-data',
  ContactsLs = 'contacts-ls',
  FaxLs = 'fax-ls',
  AppVersionBanner = 'appVersionBanner',
  NotificationsBanner = 'notificationsBanner',
  FaxEmailConfirmations = 'faxEmailConfirmations',
  SiteNav = 'sitenav',
  MessageDrafts = 'messageDrafts',
  WebphoneTabState = 'webphoneTabState',
  RecentCallsList = 'recentCallsList',
  RecentCallMap = 'recentCallMap',
  BlockedNumbers = 'blockedNumbers',
  DontShowAgain = 'dont-show-again',
  SpeedDial = 'speedDial',
  DesktopAppDetection = 'desktopAppDetection',
}
